
import { history } from "@gsd/redux-store-backoffice";
import React from "react";
import DocumentTitle from "react-document-title";
import { Route, Router } from "react-router-dom";

// CONTAINERS
import LogoutComponent from "./component/LogoutComponent";
import ErrorPageContainer from "./containers/ErrorPageContainer";

import {
  Acl, Application, Dashboard, Role, User
} from "./containers";


// import LogoutComponent from './component/LogoutComponent';
import MainPage from "./component/MainPage/MainPage";

// import CustomLeftPanel from './component/CustomLeftPanel';
const MAIN_TITLE = "GSD";

const routes = [
  {
    path: "/",
    exact: true,
    component: Dashboard,
    title: "Home"
  },
  {
    path: "/users",
    exact: true,
    component: User,
    title: ""
  },
  {
    path: "/acl",
    exact: true,
    component: Acl,
    title: ""
  },
  {
    path: "/roles",
    exact: true,
    component: Role,
    title: ""
  },
  {
    path: "/applications",
    exact: true,
    component: Application,
    title: ""
  },
  {
    path: "/logout",
    exact: true,
    component : LogoutComponent,
    title : ""
  },
  {
    path: "/500",
    exact: true,
    component: ErrorPageContainer,
    title: ""
  }
];
const CompWithTitle = ({ route, renderProps }: any) => {
  const Comp = route.component;
  return (
    <DocumentTitle
      title={(route.title ? route.title + " - " : "") + MAIN_TITLE}
    >
      <Comp {...renderProps} />
    </DocumentTitle>
  );
};

class Routes extends React.Component<unknown> {
  render() {
    return (
      <DocumentTitle title={MAIN_TITLE}>
        <Router history={history}>
          <MainPage>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={renderProps => (
                  <CompWithTitle
                    route={route}
                    renderProps={renderProps}
                  />
                )}
              />
            ))}
          </MainPage>
        </Router>
      </DocumentTitle>
    );
  }
}
export default Routes;
